import { useMemo } from 'react';

import { useSelectedLanguageContext } from '~/components/SelectedLanguage';
import { useNotificationList } from '~/hooks/useNotificationList';

export interface UseLegacyNotificationsOutput {
  unreadNotificationsLength: number;
}

export const useLegacyNotificationsPaper = () => {
  const { language } = useSelectedLanguageContext();
  const { notifications } = useNotificationList({ limit: 50, lang: language });
  const unreadNotificationsLength = useMemo(
    () => notifications?.filter((n) => !n.isRead).length,
    [notifications],
  );

  return {
    unreadNotificationsLength,
  };
};
